import { useContext } from 'react'
import { subscribe } from "../utils/pubsub"
import { GlobalContext } from '../GlobalContext'
import Button from '../formfields/Button'
import Card from '../ui-elements/Card'
import DeleteButton from '../formfields/DeleteButton'


type Props = {
    reportId: string
    report: ObjectStringKeyAnyValue
}

function AutomaticReportSummary({
    reportId,
    report
}: Props) {

    const {
        tableData,
        currentOrganisation,
        sendMessageToWebsocket,
        setShowModal
    } = useContext(GlobalContext)


    const getDateSuffix = (day: number) => {
        if (day > 3 && day < 21) return 'th'; //
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    }

    const saveData = () => {
        setShowModal({ "spinner": "Deleting..." })
        // generate UUID for the new automatic report
        const payload = JSON.stringify({
            "action": "portal",
            "subAction": "deleteAutomaticReport",
            "reportId": reportId
        })
        sendMessageToWebsocket(payload)
        const unsubscribe = subscribe("automaticReportDeleted", data => {
            if (data && data.Id === reportId) {
                unsubscribe()
                setShowModal(null)
            }
        })

    }


    return <Card fullwidth={true}>
        <div className={`w-full flex flex-col gap-2`}>
            <p className='text-2xl font-righteous' >{report.emailSubject || "Report"}</p>


            <div className={`w-full flex flex-col gap-2`}>
                <div className={`w-full flex flex-col`}>
                    <p className={`font-bold`}>Organisations to include:</p>

                    {report.OrganisationsToInclude && report.OrganisationsToInclude.length > 0 && <p className={``}>{report.OrganisationsToInclude.map((organisationId: string) => {
                        const organisation = tableData && tableData.Organisations && tableData.Organisations[organisationId]
                        return <span key={organisationId} className={`text-sm`}>
                            {organisation ? organisation.OrganisationName : 'Unknown Organisation'}{organisationId !== report.OrganisationsToInclude[report.OrganisationsToInclude.length - 1] ? ', ' : ''}
                        </span>
                    })}</p>}
                </div>


                <div className={`w-full flex flex-col`}>
                    <p className={`font-bold`}>Report details:</p>
                   {report && report.reportMetric && report.reportMetric === 'numberOfChecklists' && <p className={`text-sm`}>Number of checks scheduled</p>}
                    {!(report && report.reportMetric && report.reportMetric === 'numberOfChecklists') && <p className={`text-sm`}>Percentage of checks completed</p>}

                   {report.Frequency === 'weekly' &&
                        <p className={`text-sm`}>Sent Weekly
                            {report.dayOfWeek && ` on ${report.dayOfWeek}`}
                        </p>}
                        {report.Frequency === 'monthly' &&
                        <p className={`text-sm`}>Sent Monthly 
                        </p>} 
                   <p className={`text-sm`}>
                    Report last {report.reportDurationNumber} {report.reportDurationPeriod}
                   </p>
                   <p>
                    
                   </p>
                </div> 


                <div className={`w-full flex flex-col`}>
                    <p className={`font-bold`}>Export reports:</p>
                    {report.sendReportToEmail &&
                        <p className={`text-sm`}>Email report

                            {report.EmailRecipients && report.EmailRecipients.length > 0 && " to: "}

                            {report.EmailRecipients && report.EmailRecipients.length > 0 && report.EmailRecipients.map((emailAddress: string, index: number) => {
                                return <span key={index} className={``}>
                                    {emailAddress}{index !== report.EmailRecipients.length - 1 ? ', ' : ''}
                                </span>
                            })}

                        </p>}

                    {report.sendReportToOneDrive &&
                        <p className={`text-sm`}>Save to OneDrive</p>}
                </div>
            </div>
        </div>

        <div className={`flex flex-row gap-2`}>

            <DeleteButton
                deleteFunction={saveData}
                functionParams={reportId}
                fullwidth={true}
            />
            <Button
                text={`Edit`}
                variant={`primary`}
                internalLinkUrl={`/automatic-report/${reportId}`}
                fullwidth={true}
            />
        </div>
    </Card>
}

export default AutomaticReportSummary